import React, {useEffect, useRef, useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {AccessRights} from "../../../../schemas/accessRightsModel";
import useOutsideClick from "../../../../utilities/helperHooks";
import MarkUpModalContent from "./MarkUpModalContent";
import {getCustomerInfo} from "../../../AddNewEntity/AddNewEntityActions";
import {saveMarkUpLogic} from "../../../../actions/fabricator";

const MarkUpModal = (props) => {

  const {closeModal, isOpened, isGlobal, getCustomerInfo, saveMarkUpLogic, job, AR} = props;

  const selectElement = useRef(null);
  const [markUpLogic, setMarkUpLogic] = useState({});
  const [markUpLoading, setMarkUpLoading] = useState(false);

  useOutsideClick(selectElement, () => {
    if (isOpened) {
      closeModal(false);
    }
  }, ["ui-popup--mark--small", "ui-svg-checkbox__icon", "ui-svg-checkbox__icon-checked-icon"]);

  const getProfileMarkUpLogic = async () => {
    setMarkUpLoading(true);
    if (isGlobal) {
      const profile = await getCustomerInfo(null, "Fabricator", "undefined", false);
      console.log("profile", profile);
      if (profile && profile.globalMarkUp) {
        setMarkUpLogic(JSON.parse(profile.globalMarkUp))
      }
    } else if (job) {
      await new Promise(resolve => setTimeout(resolve, 300));
      if (job.markUpLogic) {
        setMarkUpLogic(JSON.parse(job.markUpLogic));
      }
    }
    setMarkUpLoading(false);
  }

  useEffect(() => {
    if (isOpened) {
      getProfileMarkUpLogic()
    }
  }, [isOpened, isGlobal, job]);

  const saveAndCloseClick = () => {
    closeModal(false);
    saveMarkUpLogic(markUpLogic, isGlobal, job);
  }

  const saveDisabled = false;

  return (
    <div className={"ui-popup ui-popup--mark ui-popup--mark--small" + (isOpened ? " ui-popup--mark--small--opened" : "")}
         ref={selectElement}>
      <button className="ui-popup-header__close ui-popup-header__close--small" onClick={closeModal}/>
      <div className="ui-popup__header ui-popup__header--center-small">
        <span className="generic-popup-title text-uppercase">
          <FormattedMessage id="features.setup.markUpDownPopup.title"/>
        </span>
      </div>
      {markUpLoading ? (
        <div className="ui-popup-body fs-mark ui-list">
          <div className="ui-loader ui-loader--medium"/>
        </div>
      ) : <MarkUpModalContent isGlobal={isGlobal}
                              markUpLoading={markUpLoading}
                              markUpLogic={markUpLogic}
                              setMarkUpLogic={setMarkUpLogic} AR={AR}/>}
      <div className="ui-popup-footer">
        <button className={"ui-button5 ui-button--wide ui-button5--green" + (saveDisabled ? " ui-button5--disabled" : "")}
                onClick={saveDisabled ? null : saveAndCloseClick}>
          <FormattedMessage id="messageBox.buttons.saveAndClose"/>
        </button>
      </div>
    </div>
  )
};

MarkUpModal.propTypes = {
  isGlobal: PropTypes.bool,
  isOpened: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  job: PropTypes.object,
}

const mapStateToProps = (store) => {
  return {
    AR: AccessRights.get(store)
  };
};

const mapDispatchToProps = {
  getCustomerInfo,
  saveMarkUpLogic,
};

export default connect(mapStateToProps, mapDispatchToProps)(MarkUpModal)
